import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../state/store";
import ImageCarousel from './ImageCarosel';
import ProductCard from "../components/ProductCard";
import MainNavbar from "../pages/MainNavbar";
import { useAuth } from "../context/AuthContext";
import "./ProductDetail.css";
// import Loading from "./Loading";
import { addToCart } from "../state/slices/cartSlice"; // Import remains the same
import Footer from "./footers";
// import SubNavbar from "../pages/SubNavbar";
// import { loadCategories } from "../state/slices/categorySlice";
import UnauthorizedPage from "../auth/UnauthorizedPage";
import Breadcrumbs from "./Breadcrumbs";
import { calculatePrice } from "../utils/pricing";

const ProductDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  // const navigate = useNavigate();
  const { currentUser } = useAuth();
  const dispatch = useDispatch<AppDispatch>();

  const [showSubnav, setShowSubnav] = useState(false);
  const [notification, setNotification] = useState<{ message: string; type: 'success' | 'error' } | null>(null);

  const userId = currentUser?.id || "guest";
  const isLoggedIn = !!currentUser;

  // Redux data
  const products = useSelector((state: RootState) => state.product.items);
  const cartStatus = useSelector((state: RootState) => state.cart.status);
  const cartError = useSelector((state: RootState) => state.cart.error);
  const product = products.find((p) => p.id === id) || null;
  const relatedProducts = products.filter((p) => p.id !== product?.id);
  const { finalPrice, originalFinalPrice, discountPercent } = calculatePrice(product!) // force non-null
  // const categories = useSelector((state: RootState) => state.category.categories);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);


  const handleAddToCart = async () => {
    if (!isLoggedIn) {
      setNotification({ message: "Please login to add items to cart", type: "error" });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    if (!product) return <UnauthorizedPage link="/"/>;

    try {
      // Dispatch addToCart with the same arguments
      await dispatch(addToCart({ productId: product.id, userId, price:finalPrice })).unwrap();
      setNotification({ message: "Added to cart successfully!", type: "success" });
    } catch (error) {
      console.error("Add to cart error:", error);
      setNotification({ 
        message: cartError || "Failed to add to cart", 
        type: "error" 
      });
    } finally {
      setTimeout(() => setNotification(null), 3000);
    }
  };

  if (!product) return <UnauthorizedPage link='/' />;

  return (
    <div className="product_details_wrapper">
      <MainNavbar
        searchQuery=""
        setSearchQuery={() => {}}
        isLoggedIn={isLoggedIn}
        showSubnav={showSubnav}
        setShowSubnav={setShowSubnav}

        userId={userId}
      />
      <Breadcrumbs/>
      {/* <SubNavbar categories={categories} /> */}
     

      {notification && (
        <div className={`notification ${notification.type}`}>
          {notification.message}
        </div>
      )}

      <div className="product_details_container">
        <div className="product_details_images">
          <ImageCarousel images={product.images?.map((img) => img) || ["/placeholder.png"]} />
        </div>
        
        <div className="product_details_info">
          <h1>{product.name}</h1>
          <div className="product_details_price_stock">
            <div className="product_details_price">
                {discountPercent > 0 ? (
                  <>
                    <span className="discounted-price">
                      Rs. {finalPrice.toFixed(2)}
                    </span>
                    <span className="original-price">
                      Rs. {originalFinalPrice.toFixed(2)}
                    </span>
                    <span className="discount-percent">
                      ({discountPercent}% OFF)
                    </span>
                  </>
                ) : (
                  <span className="discounted-price">
                    Rs. {finalPrice.toFixed(2)}
                  </span>
                )}
              </div>
            <p className={`product_details_stock ${product.stockQuantity > 0 ? 'in_stock' : 'out_stock'}`}>
              {product.stockQuantity > 0 ? "In Stock" : "Out of Stock"}
            </p>
          </div>
          
          <button
            className="product_details_add_to_cart"
            onClick={handleAddToCart}
            disabled={product.stockQuantity <= 0 || cartStatus === "loading"}
          >
            {cartStatus === "loading" ? "Adding..." : "Add to Cart 🛒"}
          </button>
          
          <p className="product_details_desc">{product.description}</p>
          
          <div className="product_details_attributes">
            {product.attributes.map((attr, idx) => (
              <div key={idx} className="attribute_item">
                <strong>{attr.key}:</strong> {attr.value}
              </div>
            ))}
          </div>
        </div>
      </div>

      {relatedProducts.length > 0 && (
        <div className="product_details_related">
          <h2>More Products</h2>
          <div className="product_grid">
            {relatedProducts.map((prod) => (
              <ProductCard key={prod.id} product={prod} />
            ))}
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default ProductDetail;